import React, { useEffect, useState } from 'react';
import { ProgramRequestsTable } from '../admin/program-requests-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProgramRequestInstitutionRequestCard } from './program-request-institution-request-card';

export const ProgramRequestsInstitutionViewTab = data => {
    const [awaitingResponseData, setAwaitingResponseData] = useState([]);
    const [submittedData, setSubmittedData] = useState([]);
    const [approvedData, setApprovedData] = useState([]);
    const [deniedData, setDeniedData] = useState([]);
    useEffect(() => {
        console.log(data)
        if (data.data) {
            setSubmittedData(
                data.data.filter(
                    item => item.status === 'Submitted' || item.status === 'Under Review'
                )
            );
            setApprovedData(data.data.filter(item => item.status === 'Approved'));
            setDeniedData(data.data.filter(item => item.status === 'Denied'));
            setAwaitingResponseData(
                data.data.filter(item => item.status === 'Awaiting Institution')
            );
        }
    }, [data]);
    return (
        <div
            className="tab-pane fade show active"
            id="requests"
            role="tabpanel"
            aria-labelledby="requests-tab"
        >
            <div className="p-3">
                <ProgramRequestInstitutionRequestCard
                    data={awaitingResponseData}
                    cardCategoryName={'Awaiting Response'}
                />
                <ProgramRequestInstitutionRequestCard
                    data={submittedData}
                    cardCategoryName={'Submitted'}
                />
                <ProgramRequestInstitutionRequestCard
                    data={approvedData}
                    cardCategoryName={'Approved'}
                />
                <ProgramRequestInstitutionRequestCard
                    data={deniedData}
                    cardCategoryName={'Denied'}
                />
            </div>
        </div>
    );
};
